import UnsplashImageSearch from "@src/lib/ui/UnsplashImageSearch";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";
import { FC, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import Spinner from "@src/lib/ui/Spinner";
import { MAX_FILE_SIZE_BYTES } from "@src/lib/utils/files";

type Props = {
  updateImage: (url: string) => void;
  onFileSelected: (file: File) => void;
  fileUploadInProgress: boolean;
};

const CoverImagePickerImagesTab: FC<Props> = ({
  updateImage,
  onFileSelected,
  fileUploadInProgress,
}) => {
  const onDrop = useCallback(
    <T extends File>(acceptedFiles: T[]) => {
      if (acceptedFiles.length === 1) {
        onFileSelected(acceptedFiles[0]);
      }
    },
    [onFileSelected],
  );
  const { getRootProps, getInputProps, isDragActive, fileRejections } =
    useDropzone({
      useFsAccessApi: true,
      multiple: false,
      noClick: false,
      noKeyboard: true,
      onDrop,
      maxSize: MAX_FILE_SIZE_BYTES,
      accept: {
        "image/jpeg": [".jpeg", ".jpg"],
        "image/png": [".png"],
      },
    });
  return (
    <div
      className="flex flex-col"
      style={{ overflow: "scroll", marginTop: 15 }}
    >
      <div
        className={cn(
          "flex flex-col items-center justify-center self-stretch cursor-pointer rounded-lg border-2 border-dashed border-gray-5-alpha bg-gray-3-alpha",
          isDragActive && "bg-gray-4-alpha",
        )}
        style={{
          height: 75,
        }}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <div
          className="flex flex-col items-center justify-center"
          style={{ height: 87 }}
        >
          <div className="flex items-center justify-center">
            <div className="flex flex-col items-center gap-1.5">
              <Text variant="fine-print-title">
                Drag image to upload or click to browse files
              </Text>
              <div className="flex" style={{ height: 16, maxHeight: 16 }}>
                {fileUploadInProgress ? (
                  <Spinner size={16} />
                ) : fileRejections[0]?.errors[0] ? (
                  <Text variant="fine-print-description" className="text-red-9">
                    {fileRejections[0].errors[0].message}
                  </Text>
                ) : (
                  <Text variant="fine-print-description">
                    .jpeg, .png supported
                  </Text>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <UnsplashImageSearch
        containerClassName="w-[340px]"
        imageContainerClassName="m-0 p-0"
        imageClassName="h-[82px] w-[82px] p-0"
        onImageSelect={(image) => updateImage(image.urls.regular)}
        showPhotoCredit={false}
        orientation={"squarish"}
      />
    </div>
  );
};

export default CoverImagePickerImagesTab;
